<script>
  /**
   * 左右スライド スイッチ型チェックボックス
   */
  import Field from './Field.svelte'
  import { scrollOnFocus } from '../../modules/scrollOnFocus'

  export let id
  export let name
  export let label
  export let description
  export let required
  export let value = true // チェックされた場合に submit される値
  export let checked
</script>

<Field {id} {label}>
  <input
    id={`${id}Switch`}
    data-testid={`${id}Switch`}
    type="checkbox"
    class="switch is-rounded"
    {name}
    {value}
    {required}
    use:scrollOnFocus
    bind:checked
  />
  <label for={`${id}Switch`}>{description}</label>
</Field>
